import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { IDoctor } from 'src/app/shared/interfaces/doctor';
import { ApiService } from 'src/app/shared/services/api.service';
import { SearchService } from 'src/app/shared/services/search.service';

@Component({
  selector: 'app-search',
  standalone: true,
  imports: [],
  templateUrl: './search.component.html',
  styleUrl: './search.component.css'
})
export class SearchComponent {

  searchQuery: string = '';
  searchResult: IDoctor[];
  pageSize = 30;  

  constructor(
    private searchService: SearchService,
    private apiService: ApiService,
    public router: Router
  ){}

  // onSearch(query: string) {
  //   // Perform search logic here and get results (mocked here)
  //   const results = this.performSearch(query);

  //   // Update results via service
  //   this.searchService.updateSearchResults(results);

  //   this.searchService.searchQuery = this.searchQuery;
    
    
  //   this.router.navigate(['/doctors-list'])
  // }

  onSearch(query: string){
    // This would be your search logic
    // return [{ name: 'Result 1' }, { name: 'Result 2' }];  // Example results

    const params = {
      pageSize: this.pageSize,
      pageIndex: 1,
      search: query
    }

    this.apiService.apiCall('get', '/api/SiteDoctors/GetAllDoctors', {}, params).subscribe((res: any) => {
      console.log(res);

      this.searchService.updateSearchResults(res.body.model)
      this.router.navigate(['/doctors-list'])
    });

    // return this.searchResult
  }

}
